import intersection from 'lodash/intersection';
import { OptionsType, OptionTypeBase } from 'react-select';

// Selected options are sent as array of strings from BE. They need to be converted
// into array of objects with value, label attributes, bacause multiselect accept that
// format of data.

export const transformDataForMultiselect = (options: OptionsType<OptionTypeBase>, selectedValues: Array<string>) => {
  const optionValues = options.map((option) => option.value);
  const intersectionAarray = intersection(optionValues, selectedValues);
  const selectedData = intersectionAarray.map((item) => options.find((option) => option.value === item));

  return selectedData;
};

export default transformDataForMultiselect;
